import { render, staticRenderFns } from "./orderItemsPreviewDialog.vue?vue&type=template&id=7bbffeca&"
import script from "./orderItemsPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./orderItemsPreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports